// Auto-generated by /app/scripts/build_i18n.py
export const LANGUAGE_WHEEL_QUESTIONS = {
 "python": [
  {
   "q": "What does the following code print?\n\ndef add(x, lst=[]):\n    lst.append(x)\n    return lst\n\nadd(1)\nprint(add(2))",
   "options": [
    "[2]",
    "[1, 2]",
    "[1]",
    "It raises a TypeError"
   ],
   "correctIndex": 1,
   "explanation": "The default list is created once when the function is defined and shared across calls, so the second call sees the 1 appended by the first."
  },
  {
   "q": "After running the code below, what is grid?\n\ngrid = [[0] * 3] * 3\ngrid[0][0] = 1",
   "options": [
    "[[1, 0, 0], [0, 0, 0], [0, 0, 0]]",
    "[[1, 0, 0], [1, 0, 0], [1, 0, 0]]",
    "[[1, 1, 1], [0, 0, 0], [0, 0, 0]]",
    "It raises an IndexError"
   ],
   "correctIndex": 1,
   "explanation": "Multiplying the outer list copies references to the same inner list three times, so changing one row changes all of them; use [[0]*3 for _ in range(3)] instead."
  },
  {
   "q": "Which structure is the best choice for a BFS queue in Python, and why?",
   "options": [
    "list, because pop(0) is O(1)",
    "collections.deque, because popleft() is O(1)",
    "set, because it removes duplicates automatically",
    "tuple, because it is immutable and faster"
   ],
   "correctIndex": 1,
   "explanation": "deque supports O(1) appends and pops at both ends, while list.pop(0) is O(n) because every remaining element shifts."
  },
  {
   "q": "What is the value of -7 // 2 in Python 3?",
   "options": [
    "-3",
    "-4",
    "3",
    "-3.5"
   ],
   "correctIndex": 1,
   "explanation": "The // operator floors toward negative infinity, so -3.5 becomes -4 (unlike truncation in C or Java)."
  },
  {
   "q": "What happens when you run the following code?\n\ns = \"abc\"\ns[0] = \"x\"",
   "options": [
    "s becomes \"xbc\"",
    "s becomes \"x\"",
    "A TypeError is raised because strings are immutable",
    "A ValueError is raised because \"x\" is the wrong length"
   ],
   "correctIndex": 2,
   "explanation": "Python strings are immutable and do not support item assignment; you must build a new string, for example s = \"x\" + s[1:]."
  },
  {
   "q": "You must check membership of many values against a large collection of integers. Which is the most efficient choice?",
   "options": [
    "Store them in a list and use `in`",
    "Store them in a set and use `in`",
    "Store them in a tuple and use `in`",
    "Sort a list and use list.index()"
   ],
   "correctIndex": 1,
   "explanation": "Set membership is O(1) on average because it uses hashing, whereas `in` on a list or tuple is O(n)."
  },
  {
   "q": "What does a.copy() produce in the code below, and what is a afterwards?\n\na = [[1], [2]]\nb = a.copy()\nb[0].append(9)",
   "options": [
    "a is [[1], [2]] because copy() is a deep copy",
    "a is [[1, 9], [2]] because copy() is shallow and the inner lists are shared",
    "a is [[1], [2], 9]",
    "It raises an AttributeError"
   ],
   "correctIndex": 1,
   "explanation": "list.copy() makes a shallow copy, so the inner lists are the same objects; use copy.deepcopy() for fully independent nested data."
  },
  {
   "q": "Which of these can be used as a dictionary key?",
   "options": [
    "[1, 2]",
    "{1, 2}",
    "(1, 2)",
    "{1: 2}"
   ],
   "correctIndex": 2,
   "explanation": "Dictionary keys must be hashable; tuples of hashable items are hashable, while lists, sets and dicts are mutable and therefore unhashable."
  },
  {
   "q": "Python's heapq module implements a min-heap. How do you simulate a max-heap of integers?",
   "options": [
    "Pass reverse=True to heappush",
    "Push the negated values and negate them again when popping",
    "Sort the list in descending order before calling heapify",
    "Use heapq.heappop_max()"
   ],
   "correctIndex": 1,
   "explanation": "heapq has no max-heap mode, so the usual trick is to store -x so the smallest negated value corresponds to the largest original value."
  },
  {
   "q": "What does the following code print?\n\na = [3, 1, 2]\nb = a.sort()\nprint(b)",
   "options": [
    "[1, 2, 3]",
    "[3, 1, 2]",
    "None",
    "It raises a TypeError"
   ],
   "correctIndex": 2,
   "explanation": "list.sort() sorts in place and returns None; use sorted(a) if you want a new sorted list returned."
  }
 ],
 "java": [
  {
   "q": "What does the following code print?\n\nString a = new String(\"hi\");\nString b = \"hi\";\nSystem.out.println((a == b) + \" \" + a.equals(b));",
   "options": [
    "true true",
    "false true",
    "true false",
    "false false"
   ],
   "correctIndex": 1,
   "explanation": "== compares references (new String creates a separate object), while equals() compares character content."
  },
  {
   "q": "What is the value of x after: int x = Integer.MAX_VALUE; x = x + 1;?",
   "options": [
    "2147483648",
    "Integer.MAX_VALUE",
    "Integer.MIN_VALUE",
    "An ArithmeticException is thrown"
   ],
   "correctIndex": 2,
   "explanation": "Java int arithmetic silently overflows and wraps around to -2147483648 (Integer.MIN_VALUE) without throwing."
  },
  {
   "q": "What does this print?\n\nInteger a = 128, b = 128;\nSystem.out.println(a == b);",
   "options": [
    "true",
    "false",
    "Compile error",
    "Runtime exception"
   ],
   "correctIndex": 1,
   "explanation": "Integer caching only covers -128 to 127, so 128 autoboxes to two different objects and == compares references; use equals()."
  },
  {
   "q": "What happens if you call list.remove(x) on an ArrayList inside a for-each loop over that same list (and the list is then iterated further)?",
   "options": [
    "The element is removed safely and iteration continues",
    "The loop skips the element silently with no error",
    "A ConcurrentModificationException is typically thrown",
    "A compile-time error occurs"
   ],
   "correctIndex": 2,
   "explanation": "The for-each loop uses a fail-fast iterator that detects structural modification; use Iterator.remove() or removeIf instead."
  },
  {
   "q": "Given List<Integer> list = new ArrayList<>(List.of(10, 20, 30)); what is list after list.remove(1);?",
   "options": [
    "[10, 30]",
    "[10, 20]",
    "[20, 30]",
    "It throws an exception"
   ],
   "correctIndex": 0,
   "explanation": "With an int argument, remove(int index) is chosen and removes the element at index 1 (20); use remove(Integer.valueOf(1)) to remove by value."
  },
  {
   "q": "Which is generally the preferred class for a stack or queue in DSA code in Java?",
   "options": [
    "Vector",
    "Stack",
    "ArrayDeque",
    "Hashtable"
   ],
   "correctIndex": 2,
   "explanation": "ArrayDeque is unsynchronized and fast, offering push/pop/offer/poll, whereas Stack and Vector are legacy synchronized classes."
  },
  {
   "q": "A PriorityQueue<Integer> with default ordering has the values 5, 1, 3 added. What does peek() return?",
   "options": [
    "5",
    "1",
    "3",
    "It depends on insertion time only"
   ],
   "correctIndex": 1,
   "explanation": "The default PriorityQueue is a min-heap using natural ordering, so peek() returns the smallest element, 1."
  },
  {
   "q": "Which statement about sorting with a custom comparator is correct?",
   "options": [
    "Arrays.sort(int[], (a, b) -> b - a) compiles and sorts descending",
    "Arrays.sort(Integer[], (a, b) -> b - a) is needed because comparators require object types",
    "Arrays.sort never accepts comparators",
    "Collections.sort works directly on int[]"
   ],
   "correctIndex": 1,
   "explanation": "Comparators work only with object arrays like Integer[]; primitive int[] has no comparator overload (and b - a can itself overflow, so prefer Integer.compare)."
  },
  {
   "q": "Why is building a large string with s += x inside a loop a performance pitfall?",
   "options": [
    "Strings are mutable so it causes data races",
    "Each concatenation creates a new String, giving O(n²) total copying",
    "It always throws OutOfMemoryError",
    "The compiler forbids it"
   ],
   "correctIndex": 1,
   "explanation": "Strings are immutable so each += copies all prior characters; use StringBuilder.append for amortized O(1) appends."
  },
  {
   "q": "What does System.out.println('a' + 1); print?",
   "options": [
    "a1",
    "b",
    "98",
    "Compile error"
   ],
   "correctIndex": 2,
   "explanation": "In arithmetic, char is promoted to int (97), so 'a' + 1 is the int 98; you would need (char)('a' + 1) to get 'b'."
  }
 ],
 "cpp": [
  {
   "q": "Given `vector<int> v;` (empty), what happens in `for (int i = 0; i < v.size() - 1; i++) { cout << v[i]; }`?",
   "options": [
    "The loop body never runs because 0 - 1 is -1",
    "A compile-time error is raised for comparing int with size_t",
    "`v.size() - 1` wraps around to a huge unsigned value, so the loop reads out of bounds (undefined behavior)",
    "An exception `std::out_of_range` is always thrown"
   ],
   "correctIndex": 2,
   "explanation": "`size()` returns an unsigned type, so `0 - 1` wraps to SIZE_MAX, and `operator[]` does no bounds checking."
  },
  {
   "q": "After running `map<string,int> m; if (m[\"a\"] == 0) {} cout << m.size();`, what is printed?",
   "options": [
    "1",
    "0",
    "A runtime error is thrown because the key doesn't exist",
    "Compilation fails because `operator[]` can't be used on a non-const map"
   ],
   "correctIndex": 0,
   "explanation": "`operator[]` inserts a value-initialized element (0 for int) when the key is missing, so the size becomes 1; use `find` or `count` to avoid this."
  },
  {
   "q": "What is the problem with `int n = 100000; long long sq = n * n;`?",
   "options": [
    "None, because the result is assigned to a `long long`",
    "`n * n` is computed in `int` first, so signed overflow (undefined behavior) occurs before the assignment",
    "It fails to compile because int cannot be converted to long long",
    "The result is always truncated to 0"
   ],
   "correctIndex": 1,
   "explanation": "The multiplication happens in `int` (max about 2.1e9) and 1e10 overflows; write `1LL * n * n` or declare `n` as `long long`."
  },
  {
   "q": "In C++17, what do `-7 / 2` and `-7 % 2` evaluate to?",
   "options": [
    "-4 and 1",
    "-3 and 1",
    "-4 and -1",
    "-3 and -1"
   ],
   "correctIndex": 3,
   "explanation": "Integer division truncates toward zero, and `%` satisfies `(a/b)*b + a%b == a`, so the remainder takes the sign of the dividend."
  },
  {
   "q": "What does `string s = \"hello\"; cout << s.substr(1, 3);` print?",
   "options": [
    "ell",
    "el",
    "ello",
    "hel"
   ],
   "correctIndex": 0,
   "explanation": "`substr(pos, len)` takes a start position and a length (not an end index), so it gives 3 characters from index 1: \"ell\"."
  },
  {
   "q": "Which is true about `vector<int> v = {1,2,3}; auto it = v.begin(); v.push_back(4);`?",
   "options": [
    "`it` is always still valid because push_back appends at the end",
    "`it` is valid only if the vector is sorted",
    "`it` is always invalidated because push_back clears iterators",
    "`it` may be invalidated if push_back triggers a reallocation, so using it afterward is undefined behavior"
   ],
   "correctIndex": 3,
   "explanation": "When capacity is exceeded the vector reallocates, invalidating all iterators, pointers and references to its elements."
  },
  {
   "q": "After `priority_queue<int> pq; pq.push(3); pq.push(1); pq.push(4);`, what does `pq.top()` return, and how do you get a min-heap?",
   "options": [
    "1; it is already a min-heap",
    "4; use `priority_queue<int, vector<int>, greater<int>>` for a min-heap",
    "3; the first inserted element stays on top",
    "4; use `priority_queue<int, vector<int>, less<int>>` for a min-heap"
   ],
   "correctIndex": 1,
   "explanation": "The default `priority_queue` is a max-heap using `less<int>`; `greater<int>` flips it to a min-heap."
  },
  {
   "q": "What does `for (auto [k, v] : m) { v++; }` do when `m` is a `map<string,int>` (C++17)?",
   "options": [
    "Increments every value stored in the map",
    "Fails to compile because structured bindings need `auto&`",
    "Increments only the first value in the map",
    "Nothing to the map, since `k` and `v` are copies; use `auto& [k, v]` to modify values"
   ],
   "correctIndex": 3,
   "explanation": "`auto` makes a copy of each pair (so `v` is a copy); binding by reference with `auto&` modifies the map in place."
  },
  {
   "q": "Why is `sort(v.begin(), v.end(), [](int a, int b){ return a <= b; });` dangerous?",
   "options": [
    "It sorts in descending order instead of ascending",
    "Comparators must be a strict weak ordering; `<=` violates it for equal elements and can cause undefined behavior or crashes",
    "Lambdas cannot be passed to `std::sort`",
    "It is only slower, running in O(n^2) always"
   ],
   "correctIndex": 1,
   "explanation": "`comp(a, a)` must return false; returning true for equal elements breaks the requirement and can make `std::sort` run past the array bounds."
  },
  {
   "q": "Which function signature best avoids an unnecessary O(n) copy when only reading a large vector?",
   "options": [
    "`int sum(vector<int> v)`",
    "`int sum(const vector<int>& v)`",
    "`int sum(vector<int>* v)` and always pass a copy of the vector",
    "`int sum(const vector<int> v)`"
   ],
   "correctIndex": 1,
   "explanation": "Passing by value (even `const` value) copies the whole vector, while `const&` passes a read-only reference with no copy."
  }
 ],
 "c": [
  {
   "q": "Inside `void f(int a[10]) { printf(\"%zu\", sizeof(a)); }`, what does sizeof(a) give when called with an int array?",
   "options": [
    "40, assuming 4-byte ints",
    "10",
    "The size of an int pointer (e.g., 8 on a 64-bit system)",
    "A compile-time error"
   ],
   "correctIndex": 2,
   "explanation": "Array parameters decay to pointers, so sizeof(a) is the size of `int *`, not the array. Pass the length separately."
  },
  {
   "q": "What is sizeof(s) for `char s[] = \"hello\";`?",
   "options": [
    "5",
    "6",
    "7",
    "It depends on the compiler"
   ],
   "correctIndex": 1,
   "explanation": "The array holds 5 characters plus the terminating '\\0', so it is 6 bytes (strlen(s) would be 5)."
  },
  {
   "q": "Which call allocates space for 10 ints and sets every element to zero?",
   "options": [
    "malloc(10)",
    "malloc(10 * sizeof(int))",
    "calloc(10, sizeof(int))",
    "realloc(NULL, 10)"
   ],
   "correctIndex": 2,
   "explanation": "calloc allocates n*size bytes and zero-initializes them, whereas malloc leaves the memory uninitialized."
  },
  {
   "q": "What happens when `int x = INT_MAX; x = x + 1;` executes?",
   "options": [
    "x wraps around to INT_MIN, guaranteed by the standard",
    "x stays at INT_MAX (saturates)",
    "The program always aborts with an exception",
    "Undefined behavior, because signed overflow is not defined in C"
   ],
   "correctIndex": 3,
   "explanation": "Signed integer overflow is undefined behavior in C; only unsigned arithmetic is guaranteed to wrap modulo 2^N."
  },
  {
   "q": "How should you check whether two C strings `a` and `b` have equal contents?",
   "options": [
    "a == b",
    "strcmp(a, b) == 0",
    "strcmp(a, b) == 1",
    "strlen(a) == strlen(b)"
   ],
   "correctIndex": 1,
   "explanation": "== compares pointer addresses, while strcmp returns 0 when the contents are equal (and otherwise a negative or positive value, not necessarily 1)."
  },
  {
   "q": "After `int a[5] = {1};`, what are the contents of a?",
   "options": [
    "{1, 1, 1, 1, 1}",
    "{1, 0, 0, 0, 0}",
    "{1, garbage, garbage, garbage, garbage}",
    "Compile error: too few initializers"
   ],
   "correctIndex": 1,
   "explanation": "When an initializer list is shorter than the array, the remaining elements are zero-initialized."
  },
  {
   "q": "What does C do when you read `arr[10]` on `int arr[5]`?",
   "options": [
    "Throws an IndexOutOfBounds exception",
    "Returns 0 safely",
    "Undefined behavior, since C does no bounds checking",
    "Compiler always rejects the code"
   ],
   "correctIndex": 2,
   "explanation": "C does not check array bounds at runtime; out-of-range access is undefined behavior and may crash or silently corrupt data."
  },
  {
   "q": "Which statement about free() is true?",
   "options": [
    "Calling free(NULL) is safe and does nothing",
    "After free(p), p is automatically set to NULL",
    "Calling free(p) twice on the same pointer is safe",
    "free(p) can be used on pointers to local arrays"
   ],
   "correctIndex": 0,
   "explanation": "free(NULL) is a defined no-op; a double free or freeing non-heap memory is undefined, and free does not modify p, so set p = NULL yourself."
  },
  {
   "q": "In C11, what are the values of `-7 / 2` and `-7 % 2`?",
   "options": [
    "-4 and 1",
    "-3 and 1",
    "-4 and -1",
    "-3 and -1"
   ],
   "correctIndex": 3,
   "explanation": "Since C99, integer division truncates toward zero, and the remainder takes the sign of the dividend, so -7/2 is -3 and -7%2 is -1."
  },
  {
   "q": "Which is the safest way to write a qsort comparator for ints, given `const void *p, *q` with `int x = *(const int*)p, y = *(const int*)q`?",
   "options": [
    "return x - y;",
    "return (x > y) - (x < y);",
    "return x > y;",
    "return x < y;"
   ],
   "correctIndex": 1,
   "explanation": "x - y can overflow for large values, and returning only 0 or 1 isn't a valid three-way result; (x>y)-(x<y) gives -1, 0, or 1 safely."
  }
 ]
};
